import React, { useState } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { toast } from "react-toastify";
import loder from "../../../img/new.gif";
import { Forgetpassword, resetpassword } from "../../../Helper/Redux/API";

function ForgotPass() {
  const navigate = useNavigate();
  const [boxHide, setBoxHide] = useState(true);
  const [useremail, setUserEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const initialValues = {
    email: "",
  };

  const ResetValues = {
    otp: "",
    password: "",
    confirmPassword: "",
  };

  const validation = Yup.object({
    password: Yup.string().max(6).required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
  });

  const onSubmit = (values, { resetForm }) => {
    setLoading(true);
    // Handle form submission logic here
    // const data = {
    //   email: values?.email,
    // };
    dispatch(Forgetpassword(values)).then((res) => {
      if (res?.payload?.status == true) {
        // console.log("red", res?.payload.response);
        setUserEmail(res?.payload.response);
        setBoxHide(false);
        toast.success(res?.payload?.message);
        setLoading(false);
        // toast.success(res.payload.message);
      } else {
        toast.error(res?.payload?.message);
        setLoading(false);
      }
    });
  };

  const onreset = (values, { resetForm }) => {
    setLoading(true);
    const data = {
      email: useremail,
      token: values?.otp,
      password: values?.password,
      password_confirmation: values?.confirmPassword,
    };
    dispatch(resetpassword(data)).then((res) => {
      if (res?.payload?.status == true) {
        // console.log("red", res?.payload.response);
        setBoxHide(true);
        toast.success(res?.payload?.message);
        // toast.success(res.payload.message);
        navigate("/Login");
        setLoading(false);
      } else {
        toast.error(res?.payload?.message);
        setLoading(false);
      }
    });
  };
  const onback = () => {
    setBoxHide(true);
  };
  return (
    <>
      <Header />
      <section className="log_form login_all">
        <div className="container">
          <div className="row align-items-center log_div">
            <div className="col-lg-4 g-0">
              <div className="Fomr_text">
                <h2>Welcome Back!</h2>
                <p>
                  To keep connected with us please login with your personal
                  Info.
                </p>
                <Link to="/Login">
                  {" "}
                  <button className="btn">Sign </button>
                </Link>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="view-img">
                {loading && <img src={loder} className="img_load" />}

                {boxHide ? (
                  <div className="form-container login_form">
                    <h1>Enter Verifi Email</h1>
                    <p>
                      We Just Sent an Message with a Verification code to Your
                      Email. Enter Your Email.
                    </p>
                    <Formik initialValues={initialValues} onSubmit={onSubmit}>
                      <Form>
                        <div className="input_container">
                          <div className="form_input">
                            <Field
                              type="email"
                              name="email"
                              id="login_email"
                              placeholder="Enter your Email"
                            />
                          </div>
                          <br />
                          <button className="btn" type="submit">
                            Confirm
                          </button>
                        </div>
                      </Form>
                    </Formik>
                  </div>
                ) : (
                  <div className="form-container login_form">
                    <h1>Enter Verification code</h1>
                    <p>
                      We just Sent an Message with a Verification Code to{" "}
                      {useremail ? useremail : ""} Enter Code below.
                    </p>
                    <Formik
                      initialValues={ResetValues}
                      onSubmit={onreset}
                      validationSchema={validation}
                    >
                      <Form>
                        <div className="input_container">
                          <div className="form_input d-none">
                            <Field
                              type="text"
                              name="email"
                              id="token_email"
                              placeholder="Enter your verification code"
                            />
                          </div>
                          <div className="form_input">
                            <Field
                              type="text"
                              name="otp"
                              id="token_otp"
                              placeholder="Enter your verification code"
                            />
                          </div>
                          <div className="form_input">
                            <Field
                              type="text"
                              name="password"
                              id="login_password"
                              placeholder="Enter your New password"
                            />
                            <ErrorMessage
                              name="password"
                              component="div"
                              className="text-danger"
                            />
                          </div>
                          <div className="form_input">
                            <Field
                              type="password"
                              name="confirmPassword"
                              id="login_Cpassword"
                              placeholder="Enter Confirm password"
                            />
                            <ErrorMessage
                              name="confirmPassword"
                              component="div"
                              className="text-danger"
                            />
                          </div>
                          <a onClick={onback} className="Forget_text">
                            {" "}
                            I didn’t Receive the Code.{" "}
                          </a>{" "}
                          <br />
                          <button className="btn" type="submit">
                            Confirm
                          </button>
                        </div>
                      </Form>
                    </Formik>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default ForgotPass;
